import get from 'lodash.get';

const getDefaultButtonPresetId = (state) =>
  get(state, 'ws.template.meta.customization.buttonPreset', null);

export default getDefaultButtonPresetId;
